export default "__VITE_ASSET__NjD4sWmf9j$p$tBBtsdf8g__";